module.exports = __webpack_public_path__ + "img/BIT_white12.3ffe91ab.jpg";